import * as React from "react";
import { ChevronLeft, ChevronRight } from "./Icons";

interface Props {
  children: React.ReactNode;
  itemsPerSlide: number;
}

export default function Carousel(props: Props) {
  const children = React.Children.toArray(props.children);
  const itemsRef = React.createRef<HTMLDivElement>();

  function scrollTo(left: number) {
    try {
      itemsRef.current.scrollTo({
        left,
        behavior: "smooth"
      });
    } catch {
      // old browsers don't support scrollTo
      itemsRef.current.scrollLeft = left;
    }
  }

  function prev() {
    scrollTo(itemsRef.current.scrollLeft - itemsRef.current.offsetWidth);
  }

  function next() {
    scrollTo(itemsRef.current.scrollLeft + itemsRef.current.offsetWidth);
  }

  return (
    <div className="velaro-carousel">
      {children.length > 1 && (
        <button
          className="velaro-carousel-btn-prev velaro-bg-primary"
          aria-label="previous"
          onClick={() => prev()}
        >
          <ChevronLeft />
        </button>
      )}
      <div className="velaro-carousel-items-container">
        <div className="velaro-carousel-items" ref={itemsRef}>
          <div
            className="velaro-carousel-track"
            style={{
              width: `${(100 * children.length) / (props.itemsPerSlide || 1)}%`
            }}
          >
            {children.map((child, index) => (
              <div key={index} className="velaro-carousel-item">
                {child}
              </div>
            ))}
          </div>
        </div>
      </div>
      {children.length > 1 && (
        <button
          className="velaro-carousel-btn-next velaro-bg-primary"
          aria-label="next"
          onClick={() => next()}
        >
          <ChevronRight />
        </button>
      )}
    </div>
  );
}
